import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-gallery',
  imports: [CommonModule],
  templateUrl: './gallery.html',
  styleUrl: './gallery.css'
})
export class Gallery {
// Gallery Section
  images = [
    { url: 'assets/images/gallery/odissi-dance.jpg', category: 'Odissi' },
    { url: 'assets/images/gallery/Sambalpuri.jpg', category: 'Sambalpuri' },
    { url: 'assets/images/gallery/odissi-dance-2.jpg', category: 'Odissi' },
    { url: 'assets/images/gallery/Sambalpuri-2.jpg', category: 'Sambalpuri' },
    { url: 'assets/images/gallery/odissi-dance-3.jpg', category: 'Odissi' },
    { url: 'assets/images/gallery/Sambalpuri-3.jpg', category: 'Sambalpuri' },
    { url: 'assets/images/gallery/Bhuyan.jpg', category: 'Bhajan' },
    { url: 'assets/images/gallery/Govt-Awards.bmp', category: 'Govt Awards' }
  ];

  categories = [...new Set(this.images.map(img => img.category))];
  selectedCategory = 'All';

  get filteredImages() {
    return this.selectedCategory === 'All'
      ? this.images
      : this.images.filter(img => img.category === this.selectedCategory);
  }

  
  selectCategory(cat: string) {
    this.selectedCategory = cat;
  }

  // Modal Logic
  selectedImage: any = null;
  private myModal: any=null;

  openModal(img: any) {
    this.selectedImage = img;
    const modal = document.getElementById('imageModal');
    if (modal) {
      const bootstrapModal = new (window as any).bootstrap.Modal(modal);
      this.myModal = bootstrapModal;
      this.myModal.show();
    }
  }
  closeMyModal() {
    console.log("Closing modal");
    this.myModal.hide();
  }

}
